import { getStoryBySlug, searchStories } from "../story/requests";
import { Tag } from "./entities";

const getTagStory = () => getStoryBySlug("tag").then(Tag);

const getArticlesByTag = ({ tag, page, pageSize }) =>
  searchStories({ tag, page, pageSize });

export { getTagStory, getArticlesByTag };
